

const optionData = [

    {
        Icon:"/Img/Group 108-1.png",
        title:"Tailored Strategies",
        deskription:"Customized solutions that fit the unique needs of your business." 
 
     },
     {
         Icon:"/Img/Group 108-1.png",
         title:"Scalable Technology",
         deskription:"Future-proof technologies designed to grow alongside your business" 
  
      },
      {
         Icon:"/Img/Group 127.png",
         title:"Data-Driven Insights",
         deskription:"Harness the power of data to make informed decisions." 
  
      }, {
        Icon:"/Img/Group 135.png",
        title:"Seamless Integration",
        deskription:"Easily integrate our solutions into your existing infrastructure" 
 
     },
     {
         Icon:"/Img/Group 198-1.png", 
         title:"Content Marketing",
         deskription:"Nulla vitae elit libero, a pharetra augue. Donec id elit non mi porta gravida at eget metus cras justo." 
  
      },
      {
         Icon:"/Img/Group 108-1.png",
         title:"Business Agencys",
         deskription:"Customized solutions that fit the unique needs of your business." 
  
      },
      {
         Icon:"/Img/Group 108-2.png",
         title:"Tailored Strategies",
         deskription:"Customized solutions that fit the unique needs of your business." 
  
      },
      {
         Icon:"/Img/Group 127.png",
         title:"Tailored Strategies",
         deskription:"Customized solutions that fit the unique needs of your business." 
  
      },
      {
         Icon:"/Img/Group 198-1.png", 
         title:"Content Marketing",
         deskription:"Nulla vitae elit libero, a pharetra augue. Donec id elit non mi porta gravida at eget metus cras justo." 
  
      },

];

export default optionData;

